// extracted by mini-css-extract-plugin
export default {"container":"Unauthorized_container__m15cG"};